import { useQuery  } from "@apollo/client/react";
import React, { useEffect, useState } from "react";
import { GET_COURSE_PLAYER } from "../../utils/queries";
import { CoursePlayer } from "../../utils/graphql/CoursePlayer";
import { useNavigate, useParams } from "react-router-dom";
import { ScormPlayer } from "../../components";
import { ActivityType } from "../../utils/graphql/Global";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "store";
import { EXCEPTIONS_CODES } from "../../utils/constants";

export const Player = (): React.ReactElement => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { contentId = -1, activityId = -1 } = useParams<{
    contentId?: string;
    activityId?: string;
  }>();

  const [mediaUrl, setMediaUrl] = useState<string>("");
  const [loadSuccessful, setLoadSuccessful] = useState<boolean>(true);
  const [activityType, setActivityType] = useState<string>(ActivityType.NONE);

  const { loading, data, error} = useQuery<CoursePlayer>(GET_COURSE_PLAYER, {
    fetchPolicy: "no-cache",
    variables: {
      programmeId: contentId,
      activityId: activityId,
    }
  });

  useEffect(() => {
    if (data && data.player) {
      setLoadSuccessful(data?.player?.loadSuccessful || false);
      setMediaUrl(data?.player?.playerBodyModel?.uri || "");
      setActivityType(data?.player?.playerBodyModel?.activityModel?.type || ActivityType.NONE);
    }

    // TODO check scorm player errors and handle them accordingly instead of assuming all errors are auth related
    if (error) {
      if (error?.[0]?.extensions?.code === EXCEPTIONS_CODES.UnAuthorized) {
         navigate("/unauthorized");
      }
    }

  }, [data]);

  useEffect(() => {
    dispatch({
      type: "loader/showandhide",
      payload: { show: loading, message: "Loading The Player" },
    });
  }, [loading, dispatch]);

  return (
    <div>
      {data ? (
        <div>
          {loadSuccessful ? (
            activityType === ActivityType.E_LEARNING ? (
              <ScormPlayer player={data.player} />
            ) : activityType === ActivityType.VIDEO ? (
              <video
                controls
                autoPlay
                width="100%"
                height="90%"
                controlsList="nodownload"
                disablePictureInPicture={false}
                onContextMenu={() => false}
              >
                <source src={mediaUrl} />
              </video>
            ) : (
              activityType === ActivityType.AUDIO && (
                <audio controls autoPlay controlsList="nodownload" onContextMenu={() => false}>
                  <source src={mediaUrl} />
                </audio>
              )
            )
          ) : (
            <div>{t("player_source_not_found")}</div>
          )}
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};
